import { useGetRefundCodesQuery } from 'Services/ControlDataManagement/Features/RefundCode/refundCodeApi'
import type { FetchRefundCodeListParams } from 'Services/ControlDataManagement/Features/RefundCode/types'
import { ROWS_PER_PAGE_DEFAULT, SORT_ORDER_ASC } from 'Util/constants'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SELECTED_REFUND_CODE_PARAMETER_KEY = 'selectedRefundCode'

function useRefundCodesWithParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  const [params, setParams] = useState<FetchRefundCodeListParams>({
    sort_by: searchParams.get('sort_by') ?? 'id',
    sort_order: searchParams.get('sort_order') ?? SORT_ORDER_ASC,
    start_index: searchParams.get('start_index') ?? undefined,
    count: ROWS_PER_PAGE_DEFAULT
  })

  const {
    data: { resources: refundCodes } = { resources: [] },
    data: { total_results: totalResults } = { total_results: 0 },
    isFetching
  } = useGetRefundCodesQuery(params)

  const selectedRefundCodeQueryParam =
    searchParams.get(SELECTED_REFUND_CODE_PARAMETER_KEY) ?? undefined
  const [selectedRefundCodeId, setSelectedRefundCodeId] = useState(selectedRefundCodeQueryParam)

  const setQueryParams = () => {
    for (const [key, value] of Object.entries(params)) {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    }

    selectedRefundCodeId &&
      searchParams.set(SELECTED_REFUND_CODE_PARAMETER_KEY, selectedRefundCodeId)

    setSearchParams(searchParams)
  }

  useEffect(() => {
    setQueryParams()
  }, [params])

  useEffect(() => {
    if (selectedRefundCodeId) {
      setQueryParams()
    } else {
      searchParams.delete(SELECTED_REFUND_CODE_PARAMETER_KEY)
      setSearchParams(searchParams)
    }
  }, [selectedRefundCodeId])

  return {
    refundCodes,
    isFetching,
    totalResults,
    params,
    setParams,
    selectedRefundCodeId,
    setSelectedRefundCodeId
  }
}

export default useRefundCodesWithParams
